<template>
  <div>
    <!-- <SelectProject v-if="selectAssignment == 'SelectProject'" v-on:updateView="updateView"></SelectProject> -->
    <NewProject
      v-if="selectAssignment == 'NewProject'"
      @close="closePopup"
      @updateView="updateView"
      ref="newProject"
    ></NewProject>
    <LinkedOkr
      v-else-if="selectAssignment == 'LinkedOkr'"
      ref="LinkedOkr"
      :modalInfo="projectData"
      @updateView="updateView"
      @close="closePopup"
    ></LinkedOkr>
    <!-- <AddOkrMember
      v-else
      ref="AddOkrMember"
      @updateView="updateView"
      @close="closePopup"
    ></AddOkrMember> -->
    <!-- <footer class="modal-footer">
        <slot name="footer">
          <button type="button" class="btn_ty1" @click="registProject">
            저장
          </button>
          <button type="button" class="btn_ty2" @click="previous">
            이전 화면
          </button>
        </slot>
      </footer> -->
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import NewProject from "./NewProject";
// import SelectProject from "./SelectProject";
import LinkedOkr from "./LinkedOkr";
import AddOkrMember from "./AddOkrMember";
export default {
  components: {
    // SelectProject: SelectProject,
    NewProject: NewProject,
    LinkedOkr: LinkedOkr,
    AddOkrMember: AddOkrMember,
  },
  data() {
    return {
      selectAssignment: "NewProject",
      arrData: {},
      projectData: {},
      toastInfo: {
        obj: this.$toasted,
        message: this.$i18nUtil.trans("TB013", "과제가 등록되었습니다."),
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      data: {
        url: "",
        sendType: "",
        obj: "",
        req: "",
      },
    };
  },
  methods: {
    ...mapMutations("project", ["setCreateProjectMemberList"]),
    ...mapActions("modals", ["showModal"]),
    updateView(param) {
      this.projectData = param.projectData;
      this.selectAssignment = param.view;
    },
    closePopup() {
      this.setCreateProjectMemberList([]);

      this.$emit("close");
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/CreateProject.vue